import { all, put, select, takeEvery } from 'redux-saga/effects';
import DisclosureTypes from './DisclosureTypes';
import createRequest from '../../api/httpRequest';
import snakecaseKeys from 'snakecase-keys';
import API from '../../api/data';
import Util from '../../utils/Util';
import { getCompanyDomain } from '../company/companySelector';
import { SECTION_TYPES } from '../../configs/AppConfig';

function * loadDisclosureTop () {
  yield takeEvery(DisclosureTypes.GET_DISCLOSURE_TOP_REQUEST, _loadDisclosureTop);
}

function * _loadDisclosureTop ({ payload }) {
  const domain = yield select(getCompanyDomain);
  const request = snakecaseKeys({ ...payload, domain });
  yield createRequest({
    api: {
      ...API.GET_SUMMARY_DATA,
      params: request
    },
    onSuccess: function * (response) {
      yield put({
        type: DisclosureTypes.GET_DISCLOSURE_TOP_SUCCESS,
        payload: Util.toCamelCaseKey(response.data)
      });
    }
  });
}

function * loadPatientGroupTop () {
  yield takeEvery(DisclosureTypes.GET_PATIENT_GROUP_TOP_REQUEST, _loadPatientGroupTop);
}

function * _loadPatientGroupTop ({ payload }) {
  const domain = yield select(getCompanyDomain);
  const request = snakecaseKeys({ ...payload, domain });
  yield createRequest({
    api: {
      ...API.GET_SUMMARY_DATA,
      params: request
    },
    onSuccess: function * (response) {
      yield put({
        type: DisclosureTypes.GET_PATIENT_GROUP_TOP_SUCCESS,
        payload: Util.toCamelCaseKey(response.data)
      });
    }
  });
}

function * loadSectionDetail () {
  yield takeEvery(DisclosureTypes.GET_SECTION_DETAIL_REQUEST, _loadSectionDetail);
}

function * _loadSectionDetail ({ payload }) {
  const domain = yield select(getCompanyDomain);
  const request = snakecaseKeys({ ...payload, domain });
  yield createRequest({
    api: {
      ...API.GET_SECTION_DETAIL_LIST,
      params: {
        ...request,
        is_preview: request.is_preview === undefined || request.is_preview === null ? true : request.is_preview
      }
    },
    onSuccess: function * (response) {
      yield put({
        type: DisclosureTypes.GET_SECTION_DETAIL_SUCCESS,
        payload: Util.toCamelCaseKey(response.data)
      });
      yield put({
        type: DisclosureTypes.UPDATE_QUERIES,
        payload: payload
      });
    }
  });
}

/**
 * Search data
 * @returns {Generator<<"FORK", ForkEffectDescriptor<RT>>, void, ?>}
 */
function * searchData () {
  yield takeEvery(DisclosureTypes.DO_SEARCH_REQUEST, _searchData);
}

function * _searchData ({ payload }) {
  const domain = yield select(getCompanyDomain);
  const request = snakecaseKeys({
    rootSectionIds: payload.groups,
    years: payload.years,
    organizationName: payload.organizationName,
    individualName: payload.individualName,
    domain: domain,
    sectionType: payload.type === SECTION_TYPES.DISCLOSURE.type ? SECTION_TYPES.DISCLOSURE.value : SECTION_TYPES.PATIENT.value,
    isPreview: payload.isPreview
  });

  yield createRequest({
    api: {
      ...API.GET_SEARCH_RESULT,
      params: request
    },
    onSuccess: function * (response) {
      yield put({
        type: DisclosureTypes.DO_SEARCH_SUCCESS,
        payload: Util.toCamelCaseKey(response.data)
      });
    }
  });
}

export default function * disclosureSaga () {
  yield all([
    loadDisclosureTop(),
    loadSectionDetail(),
    loadPatientGroupTop(),
    searchData()
  ]);
}
